<template>
  <div>
    <hide-elements-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :item.sync="elementEditable"
      @refetchData="refetchData"
    />

    <b-card
      no-body
    >
      <div class="card-header">
        <b-card-title>Ocultar elementos</b-card-title>
      </div>

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label> -->
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Nuevo registro</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refElementListTable"
        :items="fetchElements"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        responsive="sm"
        primary-key="id"
        empty-text="No se encontraron registros"
        show-empty
        striped
      >
        <!-- Column: Status -->
        <template #cell(status)="data">
          {{ data.item.status ? 'SI' : 'NO' }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              :id="`item-row-${data.item.id}-edit-icon`"
              icon="EditIcon"
              size="16"
              class="mx-1 cursor-pointer"
              @click="onEdit(data.item)"
            />
            <b-tooltip
              title="Editar registro"
              :target="`item-row-${data.item.id}-edit-icon`"
            />

            <div class="d-inline">
              <feather-icon
                v-if="!data.item.loading"
                :id="`item-row-${data.item.id}-delete-icon`"
                icon="TrashIcon"
                size="16"
                class="cursor-pointer"
                @click="onDelete(data.item)"
              />
              <b-spinner
                v-if="data.item.loading"
                :id="`item-row-${data.item.id}-delete-icon`"
                small
              />
              <b-tooltip
                :title="data.item.loading ? 'Eliminando...' : 'Eliminar registro'"
                :target="`item-row-${data.item.id}-delete-icon`"
              />
            </div>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalElements"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  // BDropdown,
  // BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import HideElementsAddNew from './HideElementsAddNew.vue'
import useHideElements from './useHideElements'

export default {
  components: {
    HideElementsAddNew,

    BCard,
    BTable,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
  },
  setup() {
    const {
      fetchElements,
      elementDelete,
      tableColumns,
      perPage,
      currentPage,
      totalElements,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refElementListTable,
      refetchData,

      // UI
      // resolveUserRoleVariant,
      // resolveUserRoleIcon,
      // resolveUserStatusVariant,

      // Extra Filters
      // roleFilter,
      // planFilter,
      // statusFilter,
    } = useHideElements()

    const isAddNewUserSidebarActive = ref(false)
    const elementEditable = ref(null)

    function onEdit(element) {
      elementEditable.value = { ...element }

      isAddNewUserSidebarActive.value = true
    }

    async function onDelete(element) {
      try {
        const result = await this.$swal({
          title: '¿Estas seguro?',
          text: '¡No podrás revertir esta acción!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '¡Sí, bórralo!',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (result.value) {
          // eslint-disable-next-line no-param-reassign
          element.loading = true
          await elementDelete(element.id)
          // eslint-disable-next-line no-param-reassign
          element.loading = false
          refetchData()

          this.$swal({
            icon: 'success',
            title: '¡Borrado!',
            text: 'El registro ha sido borrado',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      } catch (error) {
        console.log(error)
      }
    }

    return {
      isAddNewUserSidebarActive,
      elementEditable,
      refElementListTable,

      tableColumns,
      sortBy,
      isSortDirDesc,
      perPage,
      currentPage,
      totalElements,
      dataMeta,
      perPageOptions,
      searchQuery,
      fetchElements,
      refetchData,
      onEdit,
      onDelete,
    }
  },
}
</script>
